import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SwitchModalitaService {
  constructor() {
  }

  modificaSubject = new Subject<boolean>();

  
}
